import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getByRegister(registerId: string | number) {
  const response = await http
    .getData(`/register/${registerId}/monitoring-gds`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/monitoring-gds/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function create(data: any) {
  const response = await http.postData("/monitoring-gds", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id: number, data: any) {
  const response = await http
    .putData(`/monitoring-gds/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/monitoring-gds/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

// Rows
async function addRow(monitoringId: number, data: any) {
  const response = await http
    .postData(`/monitoring-gds/${monitoringId}/row`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateRow(monitoringId: number, rowId: number, data: any) {
  const response = await http
    .putData(`/monitoring-gds/${monitoringId}/row/${rowId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteRow(monitoringId: number, rowId: number) {
  const response = await http
    .deleteData(`/monitoring-gds/${monitoringId}/row/${rowId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// PDF
function printPdf(id: number) {
  window.open(`${http.getAPI()}/monitoring-gds/${id}/pdf`, "_blank");
}

export default {
  getByRegister,
  find,
  create,
  update,
  destroy,
  addRow,
  updateRow,
  deleteRow,
  printPdf,
};
